var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabletHandsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.11 14.25H39.95V87.99H134.11V14.25Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5099 98.45L4.43994 107.95V73.52L17.5099 98.45Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.25 140.29L127.09 144.77L93.71 144.46L95.16 134.66L128.25 140.29Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103 107.81L106.64 86.89C106.64 86.89 107.88 77.72 111.36 77.72C114.84 77.72 113.77 87.08 113.77 87.08L112.44 106.18",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103 107.81L106.64 86.89C106.64 86.89 107.88 77.72 111.36 77.72C114.84 77.72 113.77 87.08 113.77 87.08L112.44 106.18",
    stroke: "white",
    strokeWidth: 0.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1199 58.94L20.9199 51.7501C20.9199 51.7501 30.5099 46.53 32.5999 49.85C34.6899 53.17 27.1199 58.94 27.1199 58.94Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8899 49.24V11.86C27.8899 10.1016 28.5884 8.41523 29.8318 7.17186C31.0751 5.9285 32.7615 5.22998 34.5199 5.22998H140.87C142.628 5.22998 144.315 5.9285 145.558 7.17186C146.801 8.41523 147.5 10.1016 147.5 11.86V90.22C147.5 91.9784 146.801 93.6647 145.558 94.9081C144.315 96.1515 142.628 96.85 140.87 96.85H121.06",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.1 96.8499H34.5199C32.7615 96.8499 31.0751 96.1514 29.8318 94.9081C28.5884 93.6647 27.8899 91.9783 27.8899 90.2199V66.9299",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.09 54.85C142.493 54.85 143.63 53.7128 143.63 52.31C143.63 50.9072 142.493 49.77 141.09 49.77C139.687 49.77 138.55 50.9072 138.55 52.31C138.55 53.7128 139.687 54.85 141.09 54.85Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 88.1699L112.45 106.17C112.45 106.17 118.08 104.71 119.68 108.97C124.62 107.44 126.95 112.22 126.95 112.22C132.03 111.4 132.95 115.84 131.95 118.38C130.95 120.92 123.75 140 123.75 140",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0001 135.8L95.7801 117C95.3701 113.28 103.01 107.81 103.01 107.81L106.1 88.74",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7 61.26L19 53.69C19 53.69 30.58 46.69 32.62 49.85C34.66 53.01 27.78 58.3001 27.78 58.3001L17.88 65.5001L16.49 77.0001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.49 94.23L26.92 88.26",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.61 40.6799L2.5 62.9499",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletHandsGrey);
export default __webpack_public_path__ + "static/media/tablet_hands_grey.f797a6d45cdd3c6090931acf61ba9e31.svg";
export { ForwardRef as ReactComponent };